export default __webpack_public_path__ + "static/media/promo-muggle-murders-rise_03.88c073bd.jpg";